<template>
    <el-container style="height: 100%;">
        <el-header>
            <MyHeader :tag="tag" :title="deviceInfo.projectName"></MyHeader>
        </el-header>
        <el-container>
            <el-aside width="auto">
                <MyAside :tag="tag" :pid="deviceInfo.id"></MyAside>
            </el-aside>
            <el-main>
                <keep-alive >
                    <router-view :key="$route.path"></router-view>
                </keep-alive>
                <!--<router-view></router-view>-->
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import MyHeader from '@/components/MyHeader'
import MyAside from '@/components/MyAside'
import {deviceInfo} from "@/api/device";
//import { mapGetters } from 'vuex'
export default {
    name: 'Project',
    components: { MyHeader, MyAside },
    data() {
        return{
            tag: '1',
            deviceInfo:{}
        }
    },
    computed: {
        /*...mapGetters([
            'deviceInfo'
        ])*/
    },
    created() {
        let pid=Number(this.$route.query.pid)
        deviceInfo({pid:pid}).then(response => {
            if(response.code!=200){
                this.$message.error(response.msg)
            }else {
                console.log('Project获取到deviceInfo',deviceInfo)
                this.deviceInfo = response.data
            }
        })
    }
}
</script>

<style lang="scss" scoped>
.el-header{
    padding: 0;
}
</style>
